// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"375":"reg-proyects","535":"login","871":"proyectos","944":"editar-proyect"}[chunkId] + "." + {"375":"03214dfc","535":"c4137802","871":"128bf675","944":"4f1c4960"}[chunkId] + ".js";
};